var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('quiz-app-authenticated-view',{model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}):_c('div',{staticClass:"min-h-screen flex justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"},[_c('quiz-app-authentication-form',{on:{"success":function($event){_vm.data = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }